import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { amenityObject } from 'config/content';

import './PaginationSummary.scss';
import { simpleAmenityTextMap } from '../../../config/amenityMap';

const NMP_KEYWORD_LABEL = {
	'24-hour': '24 Hour Self Storage Facilities',
	'climate-controlled': 'Climate Controlled Self Storage Facilities',
	'drive-up': 'Drive Up Self Storage Facilities',
	electricity: 'Self Storage Facilities With Electricity',
	mini: 'Facilities with Mini Self Storage',
	small: 'Facilities with Small Self Storage',
	medium: 'Facilities with Medium Self Storage',
	large: 'Facilities with Large Self Storage',
	lockers: 'Facilities with Self Storage Lockers',
	boat: 'Boat Self Storage Facilities',
	car: 'Car Self Storage Facilities',
	rv: 'RV Self Storage Facilities',
	deals: 'Local Self Storage Deals',
};

export function PaginationSummary({
	city,
	state,
	listingsPerPage,
	page,
	pageListingsCount = 0,
	totalItems = 0,
	amenityType,
	pageType,
	subPageType,
}) {
	const first = pageListingsCount ? (page - 1) * listingsPerPage + 1 : 0;
	const last = pageListingsCount ? first + pageListingsCount - 1 : 0;
	const isSpecialAmenity =
		amenityType === 'climate-controlled' ||
		amenityType === '24-hour-access' ||
		amenityType === 'drive-up-self-storage' ||
		amenityType === 'free-truck-rental';

	if (
		pageType === 'nearMeSearchPage' &&
		subPageType &&
		NMP_KEYWORD_LABEL[subPageType]
	) {
		return (
			<>{`${subPageType !== 'climate-controlled' ? 'Browse ' : ''}${first} - ${last} of ${totalItems} ${NMP_KEYWORD_LABEL[subPageType]} ${subPageType === 'deals' ? '' : 'Near You'}`}</>
		);
	}

	return (
		<>
			{city && state ? (
				<>{`${first} - ${last} of ${totalItems} Cheap ${simpleAmenityTextMap[amenityType] || 'Self'} Storage Facilities in ${city}, ${state}`}</>
			) : (
				<>
					<Text
						size="smallMedium"
						weight="standard"
						color="placeholderGray"
						last
					>
						{' '}
						•{' '}
					</Text>
					{`${first} - ${last} of ${totalItems} ${
						amenityObject[amenityType] || 'Self'
					} ${isSpecialAmenity ? 'Facilities' : 'Storage Facilities'}`}
				</>
			)}
		</>
	);
}

PaginationSummary.propTypes = {
	city: PropTypes.string,
	listingsPerPage: PropTypes.number,
	page: PropTypes.number,
	pageListingsCount: PropTypes.number,
	state: PropTypes.string,
	totalItems: PropTypes.number,
	amenityType: PropTypes.string,
	pageType: PropTypes.string,
	subPageType: PropTypes.string,
};

export default PaginationSummary;
